// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const transactionApi = baseApi.injectEndpoints({
  // reducerPath: "transactionApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllTxnHistory: builder.query({
      query: ({ search,start_date, end_date, limit, page, orderBy, order }) => {
        return {
          url: `transaction?search=${search}&start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${limit}&orderBy=${orderBy}&order=${order}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: false,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllTxnHistoryQuery } = transactionApi;
